import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

export interface CampaignStagePrompt {
  campaign_stage_prompt_id: number;
  campaign_stage_id: number;
  prompt_id: number;

  prompt_input: "JD" | "Role";
  prompt_value: string;
  tone: 'professional' | 'persuasive' | 'casual' | 'enthusiastic';
  created_by: number;

  created_on: string;
  updated_on: string;
}

@Injectable({
  providedIn: 'root'
})
export class EmailCampaignService {

  constructor(private readonly httpClient: HttpClient) {}

  private buildUrl(path: string): string {
    return `${environment.backendurl}/${path}`;
  }

  public getCampaignStagePrompt(campaignId: number, stageId: number) {
    return this.httpClient.get<{ status: string, message: string, data: CampaignStagePrompt[] }>(this.buildUrl(`campaigns/${campaignId}/stages/${stageId}/prompt`));
  }

  public createCampaignStagePrompt(campaignId: number, stageId: number, prompt: Partial<CampaignStagePrompt>[]) {
    return this.httpClient.post<{ status: string, message: string, data: CampaignStagePrompt }>(this.buildUrl(`campaigns/${campaignId}/stages/${stageId}/prompt`), prompt);
  }

  public updateCampaignStagePrompt(campaignId: number, stageId: number, promptId: number, prompt: Partial<CampaignStagePrompt>) {
    return this.httpClient.post<{ status: string, message: string, data: CampaignStagePrompt }>(this.buildUrl(`campaigns/${campaignId}/stages/${stageId}/prompt/${promptId}`), prompt);
  }
}
